<template>
  <v-form-group class="c-toggle-button" :label="label">
    <v-form-radio-group buttons :checked="value" :disabled="disabled">
      <v-form-radio :button-variant="options[0].variant" :value="options[0].value" @change="$emit('input', $event)">{{
        options[0].text
      }}</v-form-radio>
      <v-form-radio :button-variant="options[1].variant" :value="options[1].value" @change="$emit('input', $event)">{{
        options[1].text
      }}</v-form-radio>
    </v-form-radio-group>
  </v-form-group>
</template>

<script>
export default {
  name: 'c-toggle-button',
  props: {
    label: {
      type: String,
      required: true
    },
    value: {
      required: true
    },
    options: {
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss" scoped>
@import '~@/styles/components/custom/c-toggle-button';
</style>
